import Link from "next/link";

const RETURN_POLICY_URL =
  "https://support.net32.com/hc/en-us/articles/28136939501203-Is-my-product-eligible-for-a-return";
const SHIPPING_POLICY_URL =
  "https://support.net32.com/hc/en-us/articles/41919340147987-How-Does-Shipping-Work-on-Net32";

/**
 * "Each Net32 vendor has their own specific return policy and shipping criteria…", with links to the vendor
 * list and the help center's return and shipping articles. `trackingAttribute` names the data attribute each
 * link carries, valued with the link it is.
 */
export default function PolicyLinksText({
  className,
  linkClassName,
  trackingAttribute,
  onVendorListClick,
}: PolicyLinksTextProps) {
  const tracking = (link: string) => ({ [trackingAttribute]: link });

  return (
    <p className={className}>
      Each Net32 vendor has their own specific return policy and shipping criteria, cataloged on our{" "}
      <Link
        href="/vendor"
        target="_blank"
        rel="noopener noreferrer"
        prefetch={false}
        className={linkClassName}
        onClick={onVendorListClick}
        {...tracking("vendor-list")}
      >
        Vendor List
      </Link>{" "}
      page. For general information, refer to the{" "}
      <a
        href={RETURN_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        {...tracking("return-policy")}
      >
        Return Policy
      </a>{" "}
      or the{" "}
      <a
        href={SHIPPING_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        {...tracking("how-shipping-works")}
      >
        How Shipping Works
      </a>{" "}
      pages.
    </p>
  );
}

interface PolicyLinksTextProps {
  className?: string;
  linkClassName?: string;
  /** e.g. "data-policies-link" */
  trackingAttribute: `data-${string}`;
  onVendorListClick?: () => void;
}
